import { parse, unparse } from "papaparse";
import {
  createEmptyRow,
  isImageHttpUrl,
  isRowEmpty,
} from "./produceRows";

const normalizeHeader = ({ value }) =>
  String(value || "")
    .trim()
    .toLowerCase();

const toSafeFileName = ({ name }) => {
  const safe = String(name || "plantilla")
    .trim()
    .replace(/[^\w-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
  return safe || "plantilla";
};

const buildHeaderMap = ({ columns, headers = [] }) => {
  const map = {};
  columns.forEach((column) => {
    const match = headers.find((header) => {
      const normalized = normalizeHeader({ value: header });
      return (
        normalized === normalizeHeader({ value: column.key }) ||
        normalized === normalizeHeader({ value: column.label })
      );
    });
    if (match) map[column.key] = match;
  });
  return map;
};

const mapCsvValue = ({ value, type }) => {
  const text = String(value ?? "").trim();
  if (!text) return "";
  if (type === "image" && !isImageHttpUrl({ value: text })) return "";
  return text;
};

const mapCsvRow = ({ raw = {}, columns, headerMap }) => {
  const row = createEmptyRow({ columns });
  columns.forEach((column) => {
    const header = headerMap[column.key];
    row[column.key] = mapCsvValue({
      value: header ? raw[header] : "",
      type: column.type,
    });
  });
  return row;
};

export const parseProduceCsvFile = ({ file, columns }) =>
  new Promise((resolve, reject) => {
    parse(file, {
      header: true,
      skipEmptyLines: "greedy",
      complete: (results) => {
        const headerMap = buildHeaderMap({
          columns,
          headers: results.meta?.fields || [],
        });
        const rows = (results.data || [])
          .map((raw) => mapCsvRow({ raw, columns, headerMap }))
          .filter((row) => !isRowEmpty({ row, columns }));
        resolve(rows);
      },
      error: (error) => reject(error),
    });
  });

export const downloadProduceFormatCsv = ({ columns, templateName }) => {
  const fields = columns.map((column) => column.key);
  const csv = unparse({
    fields,
    data: [createEmptyRow({ columns })],
  });
  const blob = new Blob([`\uFEFF${csv}`], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${toSafeFileName({ name: templateName })}-formato.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
